import i18n from '../../common/i18n';

export const streamErrorCodes = {
    USER_NOT_LOGGED_IN: 'stream.error.notLoggedIn',
    EVENT_NOT_RUNNING: 'stream.error.notRunning',
    EVENT_OVER: 'stream.error.notRunning',
    EVENT_NOT_STARTED: 'stream.starting.soon',
    STREAM_NOT_AVAILABLE: 'stream.not.available',
    STREAM_FUP: 'stream.fup',
    USER_NOT_VERIFIED: 'stream.error.notVerified',
    FORBIDDEN_STREAM1: 'stream.error.forbiddenStream1',
    FORBIDDEN_STREAM2: 'stream.error.forbiddenStream2',
    FORBIDDEN_STREAM3: 'stream.error.forbiddenStream3',
    GEO_BLOCK: 'stream.geo.blocked',
    TECHNICAL_PROBLEM: 'stream.technical.problem'
};

export const getStreamErrorMessage = (code: keyof typeof streamErrorCodes | string, params?: {}) => {
    return i18n(streamErrorCodes[code] || streamErrorCodes.TECHNICAL_PROBLEM, params) || '';
};
